import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import { APP_SELECTOR } from '@constants';
import { App } from '@pages';
import { store } from '@store';
import { history } from '@share/utils';

import reportWebVitals from './reportWebVitals';

import 'antd/dist/antd.css';
import 'antd/dist/antd.min.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'react-image-gallery/styles/scss/image-gallery.scss';
import './assets/scss/style.scss';
import './assets/scss/main-theme.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'flatpickr/dist/flatpickr.min.css';
import './assets/css/style.css';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ScrollToTop } from './components/components/common/scroll-to-top';

const appNode = document.querySelector(APP_SELECTOR);
const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
if (appNode) {
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <Router history={history}>
          <ScrollToTop />
          <GoogleOAuthProvider clientId={clientId}
          >
            <App isWidget={true} />
          </GoogleOAuthProvider>
        </Router>
      </Provider>
    </BrowserRouter>,
    appNode,
  );
}

reportWebVitals();
